import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import ErrorPagesNotFound from '@jira/router-routes__common/src/ui/error-pages/not-found/index.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { projectSettingsCustomerServiceFeaturesRoute } from '@jira/router-routes__project-settings-customer-service-routes/src/projectSettingsCustomerServiceFeaturesRoute.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { featuresResource } from '@jira/router-resources__service-project-features/src/featuresResource.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { projectSettingFeaturesAppPageEntryPoint } from './ui/project-settings-features/index.tsx';

export const projectSettingsCustomerServiceFeaturesRouteEntry: Route = createEntry(
	projectSettingsCustomerServiceFeaturesRoute,
	() => ({
		group: 'project-settings-servicedesk',
		ufoName: 'jcs-project-settings.features',
		// eslint-disable-next-line no-restricted-syntax
		component: ErrorPagesNotFound,

		entryPoint() {
			return projectSettingFeaturesAppPageEntryPoint;
		},

		layout: serviceProjectLayout,

		navigation: {
			sidebarId: SidebarIdProjectSettings,
		},

		resources: [
			...getServiceDeskSettingsResources(),
			featuresResource,
			getConsolidationStateResource(),
		],

		forPaint: [LazyAtlassianNavigation],
		perfMetricKey: 'jcs-project-settings.features',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
